import React, { useRef, useEffect, useState } from "react";
import { Canvas, useFrame, useThree } from "@react-three/fiber";
import { OrbitControls, useGLTF } from "@react-three/drei";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader.js";
import { useParams, useLocation } from "react-router-dom";
import { getMissingFloors } from './ImpFunc';

function Map({ targetObjects, fileName }) {
  const { scene, nodes } = useGLTF("/" + fileName);
  const { id } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  // const containerNumber = ;

  const [isViewContainerDetail, setIsViewContainerDetail] = useState(false);
  const [containerData, setContainerData] = useState([]);
  const [findContainer, setFindContainer] = useState("");
  const [cameraTarget, setCameraTarget] = useState({ x: 80, y: 20, z: 15 });
  const [containerNumber, setcontainerNumber] = useState(searchParams.get("container_no"));
  // const [clickedPoint, setClickedPoint] = useState(null);
  const [DefaultCamra, setDefaultCamra] = useState(null);
  const [LastSearchObjectName, setLastSearchObjectName] = useState(null);

  // useEffect(() => {
  //   // Set the camera target based on some condition or interaction
  //   DefaultCamra(new THREE.Vector3(10, 10, 10)); // Example target
  // }, []);

  useEffect(() => {
    // Function to create a container
    // alert(container);
    setDefaultCamra(new THREE.Vector3(-20, 20, -50));

    const createContainer = (position, color) => {
      const geometry = new THREE.BoxGeometry(6.1, 2.44, 2.44); // Container size 6.1x2.44x2.44

      // const material = new THREE.MeshStandardMaterial({
      //   color,
      //   transparent: true, // Enable transparency
      //   opacity: 0.8, // Set the opacity (0.0 to 1.0, where 0.0 is fully transparent and 1.0 is fully opaque)
      // });
      const material = new THREE.MeshStandardMaterial({
        color,
        transparent: true,
        opacity: 0.8,
        depthWrite: true,
        side: THREE.FrontSide, // Render only the front side
      });

      const container = new THREE.Mesh(geometry, material);
      // const container = new THREE.Line(geometry, material);

      container.position.copy(position);
      return container;
    };

    targetObjects.forEach((data) => {
      if (data.last_stk_loc) {

        let rawLoc = data.last_stk_loc ?? '';
        rawLoc = rawLoc.endsWith('*') ? rawLoc.slice(0, -1) : rawLoc;
        let name = (rawLoc.replace('/', '-').slice(0, -1)).replace(/^0/, '');
        const floor = rawLoc.slice(-1) ?? 'A';

        const container_no = data.container_no ?? null;

        let color = "#79c9b4";
        if (data.container_size == '40') {
          console.log(data.container_size)
          color = '#93c9e4';
        }

        const parts = name.split("-");
        if (parts.length > 1) {
          const prefix = parts[0];
          // console.log(prefix);
          if (prefix <= 7) {
            parts[0] = (600 + parseInt(prefix)).toString(); // e.g. 01 → 601
            name = parts.join("-");
            // console.log('S1 Naming is :: ' + name)
          }
        }
        // console.log(name);

        const obj = nodes[name];
        // console.log('Nodes is :: '+JSON.stringify(obj));

        if (container_no == containerNumber && obj) {
          color = "red";
          setIsViewContainerDetail(true)
          setContainerData(data)
          setFindContainer(containerNumber);
          const objectPos = obj.position;
          setCameraTarget(objectPos);
        }

        if (obj) {
          // Calculate position to place the container relative to the target object
          const position = new THREE.Vector3();
          obj.getWorldPosition(position);

          // Adjust y-coordinate based on floor
          switch (floor) {
            case "A":
              position.y = 2; // Ground floor
              break;
            case "B":
              position.y = 5; // 1st floor
              break;
            case "C":
              position.y = 8; // 2nd floor
              break;
            case "D":
              position.y = 11; // 3rd floor
              break;
            default:
              position.y = 3;
              break;
          }
          // Create and add the container
          const container = createContainer(position, color);
          container.c_name = "container-" + name + floor;
          container.data = data;
          container.name = container_no;
          scene.add(container);
        }
      }
    });


    //  const missingFloor = getMissingFloors(targetObjects);
    //   console.log(missingFloor);


    const missingFloors = getMissingFloors(targetObjects);
    // console.log("Missing Floors:", JSON.stringify(missingFloors));

    missingFloors.forEach(({ locationName, missingFloor }) => {
      // Convert location name like "012/095" to the node name used in `nodes`
      let name = locationName.replace('/', '-').replace(/^0/, '');
      const parts = name.split("-");

      if (parts.length > 1) {
        const prefix = parts[0];
        if (prefix <= 7) {
          parts[0] = (600 + parseInt(prefix)).toString();
          name = parts.join("-");
        }
      }

      const obj = nodes[name];

      if (obj) {
        const position = new THREE.Vector3();
        obj.getWorldPosition(position);

        // Adjust Y position based on floor
        switch (missingFloor) {
          case "A":
            position.y = 2;
            break;
          case "B":
            position.y = 5;
            break;
          case "C":
            position.y = 8;
            break;
          case "D":
            position.y = 11;
            break;
          default:
            position.y = 3;
            break;
        }

        // Create and add the dummy (missing) container
        const dummy = createContainer(position, 'lightyellow'); // Yellow
        dummy.c_name = `missing-${name}${missingFloor}`;
        dummy.name = `missing-${name}${missingFloor}`;
        dummy.isDummy = true; // Optional flag
        scene.add(dummy);
      }
    });

    const obj2 = nodes['mainCuble'];

    if (obj2) {
      // Change the color of the object
      obj2.material = new THREE.MeshStandardMaterial({ color: 'lightBlue' }); // Red color

    }



  }, [targetObjects, nodes, scene, containerNumber]);

  let intervals = {};

  const FindContainerChangeColor = async (scene, objectName, newColor) => {
    setcontainerNumber(objectName);
  };

  function oldSearchRemove(scene, objectName, newColor) {
    scene.traverse((object) => {
      if (object.name === objectName) {
        if (object.material) {
          // Reset the color and clear intervals for this object
          object.material.color.set(newColor);
          setIsViewContainerDetail(true);
          // setContainerData(object.data);

          // if (intervals['GAOU2519850']) {
          //   intervals['GAOU2519850'].forEach(intervalId => clearInterval(intervalId));
          //   delete intervals['GAOU2519850'];
          // }
        } else {
          console.error(`Object ${objectName} does not have a material.`);
        }
      }
    });
    setIsViewContainerDetail(false);
  }


  const handleClickZoom = (event) => {
    // const point = new THREE.Vector3();
    // point.copy(event.point);
    // setCameraTarget(point);
  };

  const objectClick = (event) => {
    // alert(JSON.stringify(event.object));
    console.log(JSON.stringify(event.object.c_name))
    console.log(JSON.stringify(event.object.name))
    if (
      event.object &&
      event.object.c_name &&
      event.object.c_name.includes("container")
    ) {
      // var regex = /^container-(08|09|[1-4][0-9]|50)-\d+[A-Z]*$/;
      const regex = /^container-\d{2,3}-\d+[A-Z]*$/;
      if (regex.test(event.object.c_name) && event.object.name) {
        const objectName = event.object.name; // Track object by name
        const objectPos = event.object.position;
        // alert(JSON.stringify(objectPos));
        setCameraTarget(objectPos);
        setcontainerNumber(objectName);
        console.log("Object Name:", objectName);
      }
    }
  };

  const CameraController = ({ target }) => {
    const { camera, gl } = useThree();
    const controlsRef = useRef();

    useEffect(() => {
      if (target && controlsRef.current) {
        // Move camera to the new position once
        camera.position.set(target.x + 10, target.y + 30, target.z + 50);

        // Make the controls look at the target
        controlsRef.current.target.copy(target);
        controlsRef.current.update();
      }
    }, [target]); // Runs only when target changes
    // 0, 80, 30
    return <OrbitControls ref={controlsRef} args={[camera, gl.domElement]} />;
  };


  const handleFullscreen = () => {
    alert('test');
    const elem = document.documentElement; // full page
    if (!document.fullscreenElement) {
      elem.requestFullscreen().catch(err => {
        console.error(`Error trying to enable full-screen mode: ${err.message}`);
      });
    } else {
      document.exitFullscreen();
    }
  };

  return (
    <>
      {/* {LastSearchObjectName} */}
      {/* {JSON.stringify(intervals)} */}

      <div className="row">
        <div
          style={{
            position: "absolute",
            right: 0,
            width: "auto",
            marginTop: "10px",
            zIndex: 999,
          }}
        >
          <button className="btn btn-info" data-bs-toggle="modal" data-bs-target="#exampleModal"><i className="fa fa-search" aria-hidden="true"></i>  </button>
          {/* <button className="btn btn-primary ms-2" onClick={handleFullscreen}> <i class="fa fa-arrows-alt" aria-hidden="true"></i>  </button> */}
          <span class="badge ms-2" style={{ backgroundColor: "#79c9b4" }}>20ft Container</span>
          <span class="badge ms-2" style={{ backgroundColor: "#93c9e4" }}>40ft Container</span>
        </div>
        <div
          style={{ height: "95vh", background: "black" }}
          className={isViewContainerDetail ? "col-md-9" : "col-md-12"}
        >


          <Canvas>
            <ambientLight intensity={0.5} />
            <directionalLight position={[10, 10, 10]} intensity={1} />
            <CameraController target={cameraTarget || DefaultCamra} />

            {/* <primitive
              object={scene}
              scale={1}
              onContextMenu={(event) => {
                if (event.preventDefault) {
                  event.preventDefault();
                }
                handleClickZoom(event);
              }}
              onDoubleClick={objectClick}
            /> */}

            <primitive
              object={scene}
              scale={1}
              onContextMenu={(event) => {
                // event.preventDefault();
                handleClickZoom(event);
              }}
              onDoubleClick={(event) => {
                event.stopPropagation(); // Stop the event from propagating

                if (event.intersections.length > 0) {
                  const firstObject = event.intersections[0].object; // Get the topmost object
                  if (event.object === firstObject) {
                    objectClick(event); // Trigger click only if it's the first object
                  }
                }
              }}
            />

            <directionalLight position={[0, 0, 15]} intensity={1} />
            <directionalLight position={[0, 40, 15]} intensity={1} />
          </Canvas>
        </div>

        <div className={isViewContainerDetail ? "col-md-3" : "d-none"}>
          <div className="p-2">
            <button
              className="btn btn-outline-danger"
              // {findContainer==true : '' ? ''}
              // onClick={() => setIsViewContainerDetail(false)}
              // onClick={() => window.location = ''}
              onClick={() =>
                oldSearchRemove(scene, LastSearchObjectName, "gray")
              }
            >
              Close
            </button>
            <hr />
            {/* {JSON.stringify(containerData)} */}
            <div className="row">
              <div className="col-md-6 text-center">
                CONTAINER No : <br /> <b> {containerData.container_no ?? ''}</b>
              </div>
              <div className="col-md-6 text-center">
                ISO Code : <br />
                <b> --- </b>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-md-6 text-center">
                In From :<br /> <b>{containerData.in_from ?? ''} </b>
              </div>
              <div className="col-md-6 text-center">
                DAMAGED ? : <br />
                <b> NO </b>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-md-6 text-center">
                CONTAINER TYPE <br /> <b> {containerData.in_ldd_mt_flg ?? 'EMPTY'}</b>
              </div>
              <div className="col-md-6 text-center">
                CATEGORY <br /> <b> {containerData.type} </b>
              </div>
            </div>
            <hr />
            <div className="row">
              {/* <div className="col-md-6 text-center">
                CARGO TYPE <br /> <b> N/A</b>
              </div> */}
              <div className="col-md-6 text-center">
                LENGTH <br /> <b> {containerData.container_size} </b>
              </div>
              <div className="col-md-6 text-center">
                CREATED <br /> <b> {containerData.in_time}</b>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-md-6 text-center">
                Location <br /> <b> {containerData.last_stk_loc ?? 'EMPTY'}</b>
              </div>
              <div className="col-md-6 text-center">
                Stack <br /> <b> {containerData.stack_name} </b>
              </div>
            </div>
            <hr />
            <hr />
            {/* <h5>Here we Show container Details</h5> */}
            {/* {JSON.stringify(containerData)} */}
          </div>
        </div>



        <div
          className="modal fade"
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Find Containers
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label"
                  >
                    Container No
                  </label>
                  <input
                    type="text"
                    value={findContainer}
                    onChange={(e) => setFindContainer(e.target.value)}
                    className="form-control"
                    id="exampleFormControlInput1"
                    placeholder="Enter Container No."
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() =>
                    FindContainerChangeColor(scene, findContainer, "red")
                  }
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  Find
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Map;
